/* tslint:disable */
/* eslint-disable */
/**
 * LTCS gateway API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiV2OffersPost200Response,
  ApiV2OffersPostRequest,
  ModelError,
} from '../models/index';
import {
  ApiV2OffersPost200ResponseFromJSON,
  ApiV2OffersPost200ResponseToJSON,
  ApiV2OffersPostRequestFromJSON,
  ApiV2OffersPostRequestToJSON,
  ModelErrorFromJSON,
  ModelErrorToJSON,
} from '../models/index';

export interface ApiV2OffersPostOperationRequest {
  acceptLanguage: string;
  apiV2OffersPostRequest?: ApiV2OffersPostRequest;
  partner?: string;
}

/**
 *
 */
export class OffersApi extends runtime.BaseAPI {

  /**
   * Returns offer packages for given filters
   */
  async apiV2OffersPostRaw(requestParameters: ApiV2OffersPostOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiV2OffersPost200Response>> {
    if (requestParameters.acceptLanguage === null || requestParameters.acceptLanguage === undefined) {
      throw new runtime.RequiredError('acceptLanguage', 'Required parameter requestParameters.acceptLanguage was null or undefined when calling apiV2OffersPost.');
    }

    const queryParameters: any = {};

    if (requestParameters.partner) {
      queryParameters['partner'] = requestParameters.partner;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (requestParameters.acceptLanguage !== undefined && requestParameters.acceptLanguage !== null) {
      headerParameters['Accept-Language'] = String(requestParameters.acceptLanguage);
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }
    const response = await this.request({
      path: `/v2/offers`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: ApiV2OffersPostRequestToJSON(requestParameters.apiV2OffersPostRequest),
    }, initOverrides);
    return new runtime.JSONApiResponse(response, (jsonValue) => ApiV2OffersPost200ResponseFromJSON(jsonValue));
  }

  /**
   * Returns offer packages for given filters
   */
  async apiV2OffersPost(requestParameters: ApiV2OffersPostOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiV2OffersPost200Response> {
    const response = await this.apiV2OffersPostRaw(requestParameters, initOverrides);
    return await response.value();
  }

}
